module.exports = __webpack_public_path__ + "media/images/admin_plus-0f690bba87f392c937c125ee0aac8927.svg";